import { FC, MouseEventHandler } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Tag } from 'antd'

import Text from '~/core/Text'
import Box from '~/core/Box'
import Tooltip from '~/core/Tooltip'
import colors from '~/styles/_colors.css'
import styles from '../styles.css'

import {
    getHolesAndTapsCount,
    useShouldShowThreadTag,
    getOrderLineDisplayName,
    generateConfigInfo,
} from './logic'
import { DescriptionDataType } from './types'
import { ImOrderDetailsDisplay } from './ImOrderDetailsDisplay'

const DescriptionData: FC<DescriptionDataType> = ({
    processName,
    materialName,
    processNames,
    toggleModal,
    holes,
    twoDdrawing,
    processes,
    material,
    quoteModelRevision,
    isImOrder,
    isOrderStatusPage,
}) => {
    const { tapsCount, holesCount } = getHolesAndTapsCount(holes)

    const shouldShowThreadTag = useShouldShowThreadTag(processName)

    const displayName = getOrderLineDisplayName({
        processName,
        materialName,
    })

    const linkClick: MouseEventHandler = evt => {
        evt.stopPropagation()
        evt.preventDefault()
        toggleModal()
    }

    const showThreadTag =
        !twoDdrawing && shouldShowThreadTag && tapsCount && tapsCount > 0

    const configInfo = generateConfigInfo(quoteModelRevision)

    return (
        <>
            {isImOrder ? (
                <ImOrderDetailsDisplay
                    material={material}
                    processes={processes}
                    isOrderStatusPage={isOrderStatusPage}
                />
            ) : (
                <Text fontSize="14px" fontWeight={500} element="div">
                    {displayName} {configInfo}
                </Text>
            )}
            {(processNames || []).slice(1).map(
                (process, index) =>
                    index !== 0 && (
                        <Text
                            key={index}
                            fontSize="14px"
                            fontWeight={300}
                            element="div"
                        >
                            {process}
                            {!!processes?.[index]?.processNotes && (
                                <>
                                    &nbsp;&nbsp;
                                    <Tooltip
                                        title={processes[index].processNotes}
                                    >
                                        <InfoCircleOutlined
                                            style={{ color: colors.link }}
                                        />
                                    </Tooltip>
                                </>
                            )}
                        </Text>
                    ),
            )}
            {!!showThreadTag && (
                <Box
                    style={{
                        padding: '0',
                        margin: '0',
                    }}
                    onClick={linkClick}
                >
                    <Tag className={styles.threadTag}>
                        <Text color="success" style={{ paddingRight: '8px' }}>
                            {tapsCount}/{holesCount}
                        </Text>{' '}
                        threads configured
                    </Tag>
                </Box>
            )}
        </>
    )
}

export default DescriptionData
